export interface UseApplyElementHeightOptions {
  selector: string
  rootDocument?: Document // optional, defaults to window.document
  transform?: ((height: number) => number) | string
  timeoutMs?: number
  intervalMs?: number
}

export function useApplyElementHeight(options: UseApplyElementHeightOptions) {
  const {
    selector,
    rootDocument = document,
    transform,
    timeoutMs = 10000,
    intervalMs = 200,
  } = options

  let timer: number | null = null
  let startTime = 0

  const applyHeight = (el: HTMLElement) => {
    let height = el.getBoundingClientRect().height
    console.log(height)
    if (transform) {
      if (typeof transform === "function") {
        height = transform(height)
        console.log("changeHeight", height)
        el.style.setProperty("height", `${height}px`, "important")
      } else {
        el.style.setProperty("height", transform, "important")
        return
      }
    }
  }

  const apply = () => {
    const el = rootDocument.querySelector(selector) as HTMLElement | null
    if (el) applyHeight(el)
  }

  const waitAndApply = () => {
    startTime = Date.now()
    console.log("waitAndApply")
    timer = window.setInterval(() => {
      const el = rootDocument.querySelector(selector) as HTMLElement | null

      if (el) {
        console.log(options.selector, "exists")
        applyHeight(el)
        stop()
        return
      }
      console.log(options.selector, "not found")

      if (Date.now() - startTime >= timeoutMs) {
        stop()
      }
    }, intervalMs)
  }

  const stop = () => {
    if (timer !== null) {
      clearInterval(timer)
      timer = null
    }
  }

  return { apply, waitAndApply, stop }
}
